import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

let rolesSwiperWr = document.querySelectorAll('.roles-swiper-wr');
rolesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    swiperOnResize('(max-width: 1023px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 16,
          autoplay: {
            delay: 4500,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
          on: {
            init(swiper) {
              setTimeout(function () {
                activateSlideCard(swiper);
                window.updateJobCardsSharedLayout?.();
              }, 0)
            },
            slideChange(swiper) {
              activateSlideCard(swiper);
            },
            resize() {
              window.updateJobCardsSharedLayout?.();
            },
          },
        },
    );
  }
});

function activateSlideCard(swiper) {
  swiper.slides.forEach((slide, index) => {
    const card = slide.querySelector('.job-card');
    if (!card) return;

    if (index === swiper.activeIndex) {
      window.startJobCardHover(card);
    } else {
      window.stopJobCardHover(card);
    }
  });
}
